module.exports = __webpack_public_path__ + "img/AKW.f1796ca1.png";